import { connect } from 'react-redux'
import BulkAction from './bulk-action'
import { errorHandler } from 'pobble-components/dist/error-handler'
import {
  removePresentation,
  markAsSeen,
  markAsUnseen
} from '../../../../../../../stores/shared-presentations/shared-presentations.actions'

const mapDispatchToProps = dispatch => ({
  onMarkAsSeen: presentations =>
    presentations.forEach(
      presentation =>
        !presentation.seen && dispatch(markAsSeen(presentation.id))
    ),
  onMarkAsUnseen: presentations =>
    presentations.forEach(
      presentation =>
        presentation.seen && dispatch(markAsUnseen(presentation.id))
    ),
  onRemove: presentations =>
    presentations.forEach(presentation =>
      dispatch(removePresentation(presentation.id)).catch(errorHandler)
    )
})

export default connect(
  null,
  mapDispatchToProps
)(BulkAction)
